export const getBareDbqFieldId = (fieldId) => {
  const value = String(fieldId || '').trim();
  if (!value) return '';
  const parts = value.split('__').filter(Boolean);
  return parts.length > 0 ? parts[parts.length - 1] : value;
};

export const findDbqFieldById = (formJson, fieldId) => {
  const targetFieldId = getBareDbqFieldId(fieldId);
  if (!targetFieldId || !Array.isArray(formJson?.sections)) return null;

  const searchElements = (elements) => {
    for (const element of elements || []) {
      if (element?.type === 'field' && element?.id === targetFieldId) {
        return element;
      }
      if (element?.elements?.length) {
        const nested = searchElements(element.elements);
        if (nested) return nested;
      }
      if (element?.options?.length) {
        for (const option of element.options) {
          const nested = searchElements(option.child_elements || []);
          if (nested) return nested;
        }
      }
    }
    return null;
  };

  for (const section of formJson.sections) {
    const found = searchElements(section?.elements || []);
    if (found) return found;
  }

  return null;
};

export const formatDbqFieldValue = (field, value) => {
  const fieldType = String(field?.field_type || '').toLowerCase();

  if (value === null || value === undefined || value === '') {
    return 'No value';
  }

  if (fieldType === 'yes_no') {
    return value ? 'Yes' : 'No';
  }

  if (fieldType === 'checkbox') {
    return value ? 'Checked' : 'Unchecked';
  }

  if (fieldType === 'single_select') {
    const option = (field?.options || []).find((item) => item.id === value);
    return option?.label || String(value);
  }

  if (fieldType === 'multi_select') {
    if (!Array.isArray(value) || value.length === 0) return 'No value';
    return value
      .map((item) => (field?.options || []).find((option) => option.id === item)?.label || String(item))
      .join(', ');
  }

  return String(value);
};

export const buildInitialSuggestionValue = (field, currentValue) => {
  const fieldType = String(field?.field_type || '').toLowerCase();

  if (fieldType === 'multi_select') {
    return Array.isArray(currentValue) ? currentValue : [];
  }

  if (fieldType === 'yes_no' || fieldType === 'checkbox') {
    return typeof currentValue === 'boolean' ? currentValue : null;
  }

  if (currentValue === null || currentValue === undefined) {
    return '';
  }

  return currentValue;
};
